export default {
  title: 'Invitar nuevos integrantes',
  chooseRole: 'Selecciona el rol de los integrantes que deseas invitar.',
  chooseSecondaryRole: 'Selecciona el rol secundario de los integrantes que deseas invitar.',
  roleLabel: 'Rol',
  secondaryRoleLabel: 'Rol Krea',
  chooseLevel: 'Selecciona el nivel de los integrantes que deseas invitar.',
  levelLabel: 'Nivel',
  roleRequired: 'Debes seleccionar un rol',
  levelsRequired: 'Debes seleccionar al menos un nivel',
  emailsRequired: 'Debes ingresar al menos un email',
  levels: {
    primary: 'Primaria',
    secondary: 'Secundaria',
    both: 'Primaria y Secundaria'
  },
  emailLabel: 'Correo electrónico',
  emailPlaceholder: 'Ingresa el correo electrónico',
  usersList: {
    email: 'Email',
    role: 'Rol',
    secondaryRole: 'Rol Krea',
    level: 'Nivel',
    newUser: 'Nuevo integrante'
  },
  sendInvitations: 'Enviar invitaciones'
}

export const en = {
  title: 'Invite new members',
  chooseRole: 'Select the role of the members you want to invite.',
  chooseSecondaryRole: 'Select the secondary role of the members you wish to invite.',
  roleLabel: 'Role',
  secondaryRoleLabel: 'Krea role',
  chooseLevel: 'Select the level of the members you want to invite.',
  levelLabel: 'Level',
  roleRequired: 'You must select a role',
  levelsRequired: 'You must select at least one level',
  emailsRequired: 'You must enter at least one email',
  levels: {
    primary: 'Elementary',
    secondary: 'Secondary',
    both: 'Elementary and Secondary'
  },
  emailLabel: 'Email',
  emailPlaceholder: 'Enter email address',
  usersList: {
    email: 'Email',
    role: 'Role',
    secondaryRole: 'Krea role',
    level: 'Level',
    newUser: 'New member'
  },
  sendInvitations: 'Send invitations'
}

export const ca = {
  title: 'Convidar nous integrants',
  chooseRole: 'Selecciona el rol dels integrants que vols convidar.',
  chooseSecondaryRole: 'Selecciona el rol secundari dels integrants que desitges convidar.',
  roleLabel: 'Rol',
  secondaryRoleLabel: 'Rol Krea',
  chooseLevel: 'Selecciona el nivell dels integrants que vols convidar.',
  levelLabel: 'Nivell',
  roleRequired: 'Has de seleccionar un rol',
  levelsRequired: 'Has de seleccionar com a mínim un nivell',
  emailsRequired: 'Has d\'ingressar com a mínim un email',
  levels: {
    primary: 'Primària',
    secondary: 'Secundària',
    both: 'Primària y Secundària'
  },
  emailLabel: 'Correo electrónico',
  emailPlaceholder: 'Escriu el correu electrònic',
  usersList: {
    email: 'Correu electrònic',
    role: 'Rol',
    secondaryRole: 'Rol Krea',
    level: 'Nivell',
    newUser: 'Nou integrant'
  },
  sendInvitations: 'Enviar invitacions'
}
